import React from "react";
import { Btn } from "../../../AbstractElements";

interface PlaylistTypeModalContentProps {
  handleSubmit: (e: React.FormEvent) => void;
  type: string;
  chechStatusSubmitAndUpdate: string;
  setType: React.Dispatch<React.SetStateAction<string>>;
  handleClose: () => void;
}

const PlaylistTypeModalContent: React.FC<PlaylistTypeModalContentProps> = ({
  handleSubmit,
  type,
  setType,
  handleClose,
  chechStatusSubmitAndUpdate,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <label style={{ fontWeight: "500" }}>
        Name <span style={{ color: "red" }}>*</span>{" "}
      </label>
      <input
        type="text"
        className="form-control"
        placeholder="Enter Name"
        value={type}
        onChange={(e) => setType(e.target.value)}
        style={{
          border: "2px solid #EDEDED",
          borderRadius: "8px",
          padding: "13px",
          fontSize: "14px",
          width: "100%",
        }}
      />

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
        >
          {chechStatusSubmitAndUpdate === "Submit" ? "Submit" : "Update"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default PlaylistTypeModalContent;
